import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/PlanType/add';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_add_plan_type } from '../../../actions/v3/masterData';

const AddCategory = (props) => {
    const onSubmit = (model) => {
        v3_add_plan_type(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listPlanTypeMasterData.url);
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title="Add Plan Type">
                <Form
                    title="Add Plan Type"
                    onSubmit={onSubmit}
                    buttonName="Create Plan Type"
                />
            </Layout>
        </React.Fragment>
    );
};

export default AddCategory;
